import React from "react";
import AboutHeader from "../components/about-us/AboutHeader";
import WhyChooseUs from "../components/about-us/WhyChooseUs";

const AboutUs = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <AboutHeader />
      <WhyChooseUs/>
    </div>
  );
};

export default AboutUs;
